import { formatDistanceToNow } from 'date-fns';

type TimeSinceProps = {
  date: Date;
};

export const TimeSince = ({ date }: TimeSinceProps) => {
  return formatDistanceToNow(new Date(date), { addSuffix: true });
};
